import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import userProfileReducer from './userProfileReducer';
import orderReducer from './orderReducer';
import userReducer from './userReducer';

const rootReducer = combineReducers({
  session: sessionReducer,
  userProfile: userProfileReducer,
  order: orderReducer,
  user: userReducer
});

export default rootReducer;
